<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
        <BoardForm :baseBoard="board" :loading="loading" @submit-requested="submitRequested"></BoardForm>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import BoardForm from './BoardForm.vue'
import router from '@/router';

export default {
    data() {
        return {
            board: null,
            name: this.$route.params.name,
            loading: true
        }
    },
    components: { BoardForm },
    computed:
    {
        ...mapState('boards', ['getBoardByIdOutput']),
    },
    methods: {
        ...mapActions('boards', ['getBoardById']),
        ...mapActions('boards', ['updateBoard']),
        submitRequested(boards) {
            this.updateBoard(boards);
        },
    },
    mounted: function () {
        if (!this.$route.query.id) {
            router.push({ name: 'BoardsList' });
        }

        this.getBoardById(this.$route.query.id);
    },
    watch:
    {
        getBoardByIdOutput: function(boardOutput)
        {
            if(!boardOutput && !boardOutput.data)
            {
                router.push({ name: 'BoardsList' });
            }
            else
            {
                this.board = boardOutput.data;
                // console.log(this.board);
                this.loading = false;
            }
        }
    }
}
</script>